import posthog, { PostHog } from 'posthog-js';
import { config } from '@/config/runtime';

let initialized = false;

export const initPostHog = (): PostHog | null => {
  if (typeof window === 'undefined') return null;
  if (initialized) return posthog;

  const { posthogKey: key, posthogHost: host, posthogMaskPII: maskPII } = config;

  if (!key) return null;

  posthog.init(key, {
    api_host: host,
    ui_host: 'https://eu.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: false,
    session_recording: maskPII
      ? {
          maskAllInputs: true,
          maskTextSelector: '*',
          maskInputOptions: {
            password: true,
            email: true,
            tel: true,
            number: true,
            search: true,
            text: true,
            textarea: true,
          },
          blockSelector: '[data-ph-no-capture]',
        }
      : {
          maskAllInputs: false,
          maskInputOptions: { password: true },
          blockSelector: '[data-ph-no-capture]',
        },
    mask_personal_data_properties: maskPII,
    person_profiles: 'identified_only',
    loaded: (ph) => {
      ph.register({
        environment: config.posthogEnv || 'dev',
        pii_masked: maskPII,
      });
    },
  });

  initialized = true;

  if (typeof window !== 'undefined') {
    (window as unknown as { posthog: PostHog }).posthog = posthog;
  }

  return posthog;
};

export { posthog };
